import React, { useState, useContext, useRef, useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { FormServiceContext } from 'app/utils/contexts';
import Documentation from 'app/components/Documentation';
import notification from 'app/config/notification';
import AlertMessage from 'app/components/AlertMessage';

import { Formik, Form } from 'formik';

import TableEdit from '../Vehicles/TableEdit';
import SaveButton from 'app/components/SaveButton';
import FinalizeButton from 'app/components/FinalizeButton';

import RenderTabs from './RenderTabs';
import SearchCounty from './SearchCounty';
import ContactForm from './ContactForm';

import styles from './styles';
import RegistrationStatus from '../Registration/components/RegistrationStatus';
import { fetchCities } from 'app/store/slices/forms';
import { STATE_CITY } from 'app/utils/constants';
const useStyles = makeStyles(styles);

function SurveyRegistration(props) {
  const formContactRef = useRef();
  const dispatch = useDispatch();

  const classes = useStyles();

  const contextProps = useContext(FormServiceContext);
  const documentsStore = useSelector(state => state.services.documents);
  const cities = useSelector(state => state.forms.cities);

  const {
    initialValues,
    validateForm,
    validateOnSave,
    validationSchema,
    onSubmit,
    onSave,
    onCancel,
    mainColor,
    hideActionBtn,
    hideFinalizeBtn,
    canEdit,
    isInternalForm,
    loadingDocuments,
  } = contextProps;

  const viewsIdentification = 0;
  const viewsDocumentation = 1;

  const [view, setView] = useState(viewsIdentification);
  const showMunicipioVistoria = false;

  const handleViewChange = (event, value) => setView(value);
  const handleSaveButton = values => onSave(values);

  useEffect(() => {
    const init = async () => {
      if (cities.length === 0) {
        await dispatch(fetchCities());
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues ? initialValues : {}}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={values => onSubmit(values)}
      >
        {props => {
          return (
            <Form className={classes.containerForm}>
              <RenderTabs
                view={view}
                mainColor={mainColor}
                loadingDocuments={loadingDocuments}
                isInternalForm={isInternalForm}
                documentsStore={documentsStore}
                handleViewChange={handleViewChange}
                renderViewsDocumentation={false}
              />

              <AlertMessage isInternalForm={isInternalForm} />

              <Grid container spacing={3} className={classes.containerMainData}>
                <RegistrationStatus {...props} classes={classes} />
              </Grid>

              {view === viewsIdentification && (
                <>
                  <TableEdit {...props} contextProps={contextProps} />

                  {showMunicipioVistoria && (
                      <Grid item xs={12} sm={6}>
                        <SearchCounty
                            label="Município de preferência vistoria*"
                            formikBag={{ ...props }}
                            uf={STATE_CITY}
                            canEdit={canEdit}
                            shrink={true}
                        />
                      </Grid>
                  )}

                  <ContactForm
                    title="Contato para vistoria"
                    initialValues={initialValues}
                    innerRef={formContactRef}
                    canEdit={canEdit}
                    formikBag={{ ...props }}
                    isSurveyRegistration={true}
                  />
                </>
              )}

              {view === viewsDocumentation && (
                <Documentation {...props} contextProps={contextProps} />
              )}

              <SaveButton
                mainColor={mainColor}
                hideActionBtn={hideActionBtn}
                isInternalForm={isInternalForm}
                canEdit={canEdit}
                onCancel={onCancel}
                onSave={() => {
                  if (validateOnSave) {
                    props.validateForm().then(res => {
                      if (Object.keys(res).length <= 0) {
                        handleSaveButton(props.values, false, isInternalForm);
                      } else {
                        notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                          toastId: 'VALIDATION',
                          type: 'error',
                        });
                      }
                    });
                  } else {
                    handleSaveButton(props.values, false, isInternalForm);
                  }
                }}
              />

              <FinalizeButton
                mainColor={mainColor}
                hideFinalizeBtn={hideFinalizeBtn}
                isInternalForm={isInternalForm}
                canEdit={canEdit}
                onSubmit={() => {
                  validateForm && validateForm(props.validateForm());
                }}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default injectIntl(SurveyRegistration);
